export * from './bookmarkP';
export * from './categoryP';
export * from './contentCustomerP';
export * from './contentDubAndSubP';
export * from './contentGroupP';
export * from './contentMetadataP';
export * from './contentP';
export * from './contentPosterP';
export * from './contentReleaseDateP';
export * from './contractP';
export * from './deviceP';
export * from './homescreenVodsP';
export * from './labelP';
export * from './licenseP';
export * from './mainBoardItemP';
export * from './posterDefinitionP';
export * from './providerP';
export * from './responseObj';
export * from './responseObjOfBookmarkP';
export * from './responseObjOfContentCustomerP';
export * from './responseObjOfContentP';
export * from './responseObjOfListOfBookmarkP';
export * from './responseObjOfListOfContentP';
export * from './responseObjOfListOfHomescreenVodsP';
export * from './responseObjOfListOfLabelP';
export * from './responseObjOfListOfMainBoardItemP';
export * from './responseObjOfstring';
export * from './timestamp';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/data/cms-vod-client-api/model/models.ts